import React from 'react';
import BixCheckbox from '$/components/global/bixCheckbox';
import './index.scss';

export interface IFilterCheckbox {
  id: string;
  name: string;
  selected: boolean;
}

interface IFilterCheckboxProps {
  filters: IFilterCheckbox[];
  onFilter: (id: string, futureState: boolean) => void;
}

const FilterCheckboxes: React.FC<IFilterCheckboxProps> = props => {
  const { onFilter, filters } = props;
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onFilter) {
      onFilter(e.target.id, e.target.checked);
    }
  };

  return (
    <div className="filter_checkbox_container" role="group">
      {filters.map(filter => {
        return (
          <div key={filter.id}>
            <BixCheckbox key={filter.id} id={filter.id} checked={filter.selected} onChange={handleOnChange}>
              {filter.name}
            </BixCheckbox>
          </div>
        );
      })}
    </div>
  );
};

export default FilterCheckboxes;
